import React from 'react';
import { Stack, Typography, Box } from '@mui/material';

import ChildCard from 'src/components/shared/ChildCard';
import { IconCalendar, IconCash, IconGenderMale, IconTournament, IconTrophy } from '@tabler/icons';
import { useSelector } from 'src/store/Store';
import useLang from 'src/hooks/useLang';
import useMoment from 'src/views/pages/schedule/hooks/useMoment';
import { t } from 'i18next';
import 'src/views/forms/quill-editor/Quill.css';

enum Genders {
  MALE = 'male',
  FEMALE = 'female',
}

const IntroCard = () => {
  const selectedTournament = useSelector((state) => state.tournamentReducer.selectedTournament);
  const selectedStadium = useSelector((state) => state.configReducer.selectedStadium);

  const { getTranslatedTitle, getTranslatedCurrency } = useLang();
  const [moment] = useMoment();

  return (
    <ChildCard>
      <Typography fontWeight={600} variant="h4" mb={4}>
        {getTranslatedTitle(selectedTournament, 'name')}
      </Typography>
      {selectedTournament?.additional_info && (
        <Box
          className="ql-editor"
          sx={{
            color: 'text.secondary',
            fontSize: '0.875rem',
            mb: 4,
            padding: 0,
            '& p': { margin: '0 0 1em 0' },
            '& p:last-child': { marginBottom: 0 },
          }}
          dangerouslySetInnerHTML={{ __html: selectedTournament.additional_info }}
        />
      )}
      <Stack direction="row" gap={2} alignItems="center" mb={4}>
        <IconCalendar size={21} />
        <Typography variant="h6">{`${t('TournamentProfile.registrationDeadline')}: ${selectedTournament?.registration_deadline
          ? moment(selectedTournament?.registration_deadline).format('DD/MM/YYYY')
          : '-'
          }`}</Typography>
      </Stack>
      <Stack direction="row" gap={2} alignItems="center" mb={4}>
        <IconCalendar size="21" />
        <Typography variant="h6">{`${t('TournamentProfile.startDate')}: ${selectedTournament?.start_date
          ? moment(selectedTournament?.start_date).format('DD/MM/YYYY')
          : '-'
          }`}</Typography>
      </Stack>
      <Stack direction="row" gap={2} alignItems="center" mb={4}>
        <IconCalendar size="21" />
        <Typography variant="h6">{`${t('TournamentProfile.endDate')}: ${selectedTournament?.end_date
          ? moment(selectedTournament?.end_date).format('DD/MM/YYYY')
          : '-'
          }`}</Typography>
      </Stack>
      <Stack direction="row" gap={2} alignItems="center" mb={4}>
        <IconGenderMale size="21" />
        <Typography variant="h6">{`${t('TournamentProfile.gender')}: ${selectedTournament?.gender === Genders.MALE
          ? t('TournamentProfile.male')
          : selectedTournament?.gender === Genders.FEMALE
            ? t('TournamentProfile.female')
            : t('TournamentProfile.mixed')
          }`}</Typography>
      </Stack>
      <Stack direction="row" gap={2} alignItems="center" mb={4}>
        <IconCash size="21" />
        <Typography variant="h6">{`${t('TournamentProfile.registrationPrice')}: ${selectedTournament?.price_per_team
          ? getTranslatedCurrency(
            Number(selectedTournament?.price_per_team).toFixed(2),
            getTranslatedTitle(selectedStadium, 'main_currency_label'),
          )
          : '-'
          }`}</Typography>
      </Stack>
      <Stack direction="row" gap={2} alignItems="center" mb={4}>
        <IconTournament size="21" />
        <Typography variant="h6">{`${t('TournamentProfile.tournamentType')}: ${selectedTournament?.tournament_type
          ? getTranslatedTitle(selectedTournament?.tournament_type, 'name')
          : '-'
          }`}</Typography>
      </Stack>
      <Stack direction="row" gap={2} alignItems="center" mb={1}>
        <IconTrophy size="21" />
        <Typography variant="h6">{`${t('TournamentProfile.prizes')}: ${selectedTournament?.prizes || '-'
          }`}</Typography>
      </Stack>
    </ChildCard>
  );
};

export default IntroCard;
